import { useState } from 'react'
import { useSelector } from 'react-redux'

import { selectToken } from '../authentication/authenticationSlice'
import api, { isHTTPError } from '../api'
import {
  ErrorDetailLike,
  httpErrorReason,
} from '../../utils/httpErrorReason'

const useApiCreds = (serviceUUID: string) => {
  const [apiCreds, setApiCreds] = useState<any>([])
  const [loadingSaveApiCreds, setLoadingSaveApiCreds] = useState(false)
  const [saveCredsError, setSaveCredsError] = useState('')
  const token = useSelector(selectToken)
  const [serviceUuid, setServiceUuid] = useState(serviceUUID)

  const saveApiCreds = async (organizationId: number, apiCreds: any) => {
    try {
      setLoadingSaveApiCreds(true)
      setSaveCredsError('')
      await api.verifyApiCreds({
        token,
        serviceUuid,
        apiCreds,
        organizationId,
      })
      setLoadingSaveApiCreds(false)
    } catch (error) {
      if (isHTTPError(error) && 'detail' in error.response.data) {
        // Interpolating `detail` directly rendered "Error 429: [object Object]" — it is
        // an object for every typed error this API raises. See httpErrorReason.
        const { detail } = error.response.data as { detail: ErrorDetailLike }
        setSaveCredsError(
          `Error ${error.response.status}: ${httpErrorReason(detail)}`
        )
      } else {
        setSaveCredsError('Failed saving API credentials')
      }
      setLoadingSaveApiCreds(false)
      throw error
    }
  }

  return { apiCreds, loadingSaveApiCreds, saveApiCreds, saveCredsError }
}

export default useApiCreds
